<template>
  <apexchart width="800px" height="400px" type="bar" :options="options_3" :series="series_3" />
</template>
  <script>  
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
// import pageTitle from '@/components/GlobalComponents/PageTitleENEM.vue';
export default {
  name: 'estatisticas-enem',

  props: {},

  // components: { pageTitle },

  data() {
    return {
      pageTitle: 'Enem',
      pageSubtitle: 'Estatística',

      NamePermission: '',
      IndexPermission: '',
      options_3: {
        chart: { toolbar: { show: false } },
        dataLabels: { enabled: false },
        stroke: { show: true, width: 2, colors: ['transparent'] },
        plotOptions: { bar: { horizontal: false, columnWidth: '100%', borderRadius: 3 } },
        xaxis: {
          categories: [
            ' Filosofia Antiga ',
            'Filosofia Conteporânea ',
            'Filosofia Midieval ',
            'Filosofia Conteporânea ',
            'Filosofia Moderna ',
          ],
        },
        yaxis: {
          title: { text: 'Quantidade de Questões' }
        },
        fill: { opacity: 1 },
        // tooltip: {
        //   y: {
        //     formatter: function (val) {
        //       return '' + val + '';
        //     },
        //   },
        // },
      },

      series_3: [
        { name: '2012', data: [1] },
        { name: '2013', data: [1] },
        { name: '2014', data: [2] },
        { name: '2015', data: [1] },
        { name: '2016', data: [2] },
        { name: '2017', data: [2] },
        { name: '2018', data: [1] },
        { name: '2018', data: [0] },
        { name: '2020', data: [1] },
      ],
    };
  },

  mounted() { },

  computed: {},

  methods: {},
};
</script>
 <style scoped> 
.fade-in-up {
  margin-top: 45px;
  -webkit-animation: fadeIn 0.4s ease-in-out;
  -moz-animation: fadeIn 0.4s ease-in-out;
  -o-animation: fadeIn 0.4s ease-in-out;
  animation: fadeIn 0.4s ease-in-out;
}

.main {
  margin-top: 30px;
}

.card_sistemacpv {
    border-radius: 8px;
    color: #3A1C53;
}
</style>
